/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputFieldMasked/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaInputDatePicker from 'DesignSystem/TysiaInput/TysiaInputDatePicker/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputFieldMasked({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputFieldMasked",
  autoFocus,
  type = "text",
  tabIndex,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  value,
  disabled,
  onSubmit,
  innerRef,
  size,
  isShowingDatePicker,
  datePickerRef,
  datePickerY,
  datePickerX,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker
  
}) {
let dtTysiainputfieldColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.base'
        })
let dtTysiainputfieldColorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.hovered'
        })
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="TysiaInputFieldMasked.Capture"
  data-view-path={viewPath}
 autoFocus={autoFocus}
 tabIndex={tabIndex}
 placeholder={placeholder}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={value}
 disabled={disabled}
 onSubmit={onSubmit}
 ref={innerRef}
 style={{'--c-1-ZG7rVa': disabled ? dtTysiainputfieldColorPrimaryHovered : dtTysiainputfieldColorPrimaryBase,'--fs-2-ZG7rVa': size == "small" ? "12px" : "13px",'--lh-3-ZG7rVa': size == "small" ? "16px" : "20px"}}
 className={`views-capture ${styles.Capture}`}
/>
<fromFlow.When is={isShowingDatePicker}>
<TysiaInputDatePicker
  viewPath={`${viewPath}/TysiaInputDatePicker`}
 innerRef={datePickerRef}
 top={datePickerY}
 left={datePickerX}
 onChange={onChange}
 value={value}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}